<template>
  <div class="mass-spectrometer-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>R = mv / (qB) | m/q = RB/v$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Ion Source -->
          <rect x="20" y="180" width="40" height="30" fill="#333" stroke="#555" />
          <text x="15" y="225" fill="#888" font-size="8">离子源</text>

          <!-- Accelerator Plates -->
          <line x1="70" y1="170" x2="70" y2="220" stroke="#ffd700" stroke-width="2" />
          <text x="60" y="160" fill="#ffd700" font-size="8">加速电压 U</text>

          <!-- Entrance Slit -->
          <rect x="120" y="40" width="5" height="160" fill="#888" />
          <rect x="120" y="115" width="5" height="10" fill="none" /> <!-- The Gap -->

          <!-- Magnetic Field Region (Uniform) -->
          <rect x="125" y="40" width="220" height="160" fill="rgba(0, 210, 255, 0.05)" stroke="rgba(0, 210, 255, 0.2)" stroke-dasharray="2" />
          <text x="200" y="60" fill="rgba(0, 210, 255, 0.5)" font-size="20">×</text>
          <text x="220" y="60" fill="rgba(0, 210, 255, 0.5)" font-size="20">×</text>
          <text x="240" y="60" fill="rgba(0, 210, 255, 0.5)" font-size="20">×</text>

          <!-- Particle Trajectory -->
          <path :d="trajectoryPath" fill="none" stroke="#ff4757" stroke-width="2" stroke-dasharray="4" />
          
          <!-- End Plate (Detector/Film) -->
          <line x1="125" y1="40" x2="125" y2="115" stroke="#fff" stroke-width="3" />
          <text x="100" y="35" fill="#fff" font-size="8">照相底片</text>

          <!-- Active Particle -->
          <circle :cx="pX" :cy="pY" r="4" fill="#ff4757" v-if="animating" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>偏转半径 R: {{ radius.toFixed(1) }} px</label>
              <div class="value">m/q 越大，半径 R 越大</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>选择同位素 (质量 m)</label>
             <el-radio-group v-model="mass" size="mini">
                <el-radio-button :label="10">轻 (m1)</el-radio-button>
                <el-radio-button :label="20">中 (m2)</el-radio-button>
                <el-radio-button :label="30">重 (m3)</el-radio-button>
             </el-radio-group>
          </div>
          <div class="row">
             <el-button type="primary" size="mini" @click="startAnim">注入离子</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>质谱仪利用**洛伦兹力**使带电粒子在磁场中做匀速圆周运动。由于不同质量的离子具有不同的偏转半径，它们会落在底片的不同位置。这是分离同位素和测定原子质量最精确的方法。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MassSpectrometerViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mass: 20,
      fieldB: 5,
      velocity: 10,
      animating: false,
      pX: 0,
      pY: 0,
      progress: 0,
      timer: null
    }
  },
  computed: {
    radius() {
      // R = mv / qB. Scaling for visual.
      return (this.mass * 80) / this.fieldB / 10;
    },
    trajectoryPath() {
      let r = this.radius;
      return `M 125 120 A ${r} ${r} 0 1 1 125 ${120 - 2*r}`;
    }
  },
  beforeDestroy() {
    if (this.timer) cancelAnimationFrame(this.timer);
  },
  methods: {
    startAnim() {
      this.animating = true;
      this.progress = 0;
      if (this.timer) cancelAnimationFrame(this.timer);
      this.update();
    },
    update() {
      this.progress += 0.02;
      if (this.progress > Math.PI) {
        this.animating = false;
        return;
      }
      let r = this.radius;
      this.pX = 125 - r * Math.sin(this.progress);
      this.pY = (120 - r) + r * Math.cos(this.progress);
      
      this.timer = requestAnimationFrame(this.update);
    }
  }
}
</script>

<style scoped lang="scss">
.mass-spectrometer-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 8px; } 
}
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
